import { extendTheme, theme as base, withDefaultColorScheme } from '@chakra-ui/react';

const brandRing = {
    _focus: {
        ring: 2,
        ringColor: 'brand.500',
    }
}

const theme = extendTheme(
    {
        styles: {
            global: {
                'html, body': {
                    bg: 'none',
                    lineHeight: 'tall',
                    fontFamily: 'dinpro_regular',
                },
                a: {
                    color: 'brand.500',
                },
                'p': {
                    color: 'white',
                },
                'label': {
                    color: 'white',
                },
                'h1': {
                    color: 'white',
                    fontFamily: 'dinpro_regular',
                },
                'h2': {
                    color: 'white',
                    fontFamily: 'dinpro_regular',
                },
                'h3': {
                    color: 'white',
                    fontFamily: 'dinpro_regular',
                },
                'h4': {
                    color: 'white',
                    fontFamily: 'dinpro_regular',
                    fontWeight: 'regular',
                    lineHeight: '110%',
                    letterSpacing: '-2%',
                },
            },
        },
        shadows: {
            purple: '0 0 0 3px rgba(159, 122, 234, 0.6)',
            brand: '0px 4px 32px rgba(255, 212, 163, 0.3)'
        },
        colors: {
            brand: {
                50: '#FFD4A3',
                100: '#FFD4A3',
                200: '#FFD4A3',
                300: '#FFD4A3',
                400: '#FFD4A3',
                500: '#FFD4A3',
                600: '#FFD4A3',
                700: '#FFD4A3',
                800: '#FFD4A3',
                900: '#FFD4A3',
            },
            black: {
                100: '#000000',
            },
            white: {
                100: '#ffffff',
            },
            darkgray: {
                100: '#1B1B1B',
            }
        },
        fonts: {
            heading: `dinpro_regular, ${base.fonts?.heading}`,
            body: `dinpro_regular, ${base.fonts?.body}`,
            button: `dinpro_italic, ${base.fonts?.body}`
        },
        textStyles: {
            h1: {
                fontFamily: 'dinpro_regular',
                fontSize: ['48px', '72px'],
                fontWeight: 'regular',
                lineHeight: '110%',
                letterSpacing: '-2%',
            },
            h2: {
                fontSize: ['36px', '48px'],
                fontWeight: 'regular',
                lineHeight: '110%',
                letterSpacing: '-1%',
            },
            h4: {
                fontFamily: 'dinpro_regular',
                fontSize: ['18px', '20px'],
                fontWeight: 'regular',
                lineHeight: '110%',
                letterSpacing: '-2%',
            }
        },
        components: {
            Heading: {
                variants: {
                    h1: {
                        fontFamily: 'dinpro_regular',
                        fontSize: ['22px', '36px'],
                        fontWeight: 'regular',
                        lineHeight: '110%',
                        letterSpacing: '-2%',
                    },
                    h4: {
                        fontFamily: 'dinpro_regular',
                        fontSize: ['18px', '20px', '20px'],
                        fontWeight: 'regular',
                        lineHeight: '110%',
                        letterSpacing: '-2%',
                    }
                }
            },
            Button: {
                variants: {
                    primary: {
                        ...brandRing,
                        backgroundColor: 'brand.500',
                        color: 'black',
                        fontFamily: 'dinpro_regular',
                        _disabled: {
                            background: 'brand.500',
                            _hover: {
                                background: 'brand.500',
                            }
                        },
                        _hover: {
                            _disabled: {
                                background: 'brand.500',
                            },
                        }

                    },
                    link: {
                        color: 'brand.500',
                        _focus: {
                            ring: 0,
                        }
                    },
                    ghost: {
                        _focus: {
                            ring: 0,
                        },
                        _hover: {
                            bg: 'none'
                        },
                        _active: {
                            bg: 'none'
                        }
                    },
                    outline: {
                        ...brandRing,
                        backgroundColor: 'black',
                        color: 'brand.500',
                        fontFamily: 'dinpro_regular',
                        border: '1px solid',
                        borderColor: 'brand.500',
                        _hover: {
                            border: '1px solid brand.500',
                            backgroundColor: 'black',
                        },
                        _active: {
                            border: '1px solid brand.500',
                            backgroundColor: 'black',
                        },
                    },
                    terms: {
                        backgroundColor: 'none',
                        color: 'gray',
                        fontFamily: 'dinpro_regular',
                        _focus: {
                            ring: 0,
                        },
                        _hover: {
                            bg: 'none'
                        },
                        _active: {
                            bg: 'none'
                        }
                    },

                },
            },
            Input: {
                baseStyle: {
                    _focus: {
                        borderColor: 'brand.500',
                        backgroundColor: 'brand.500',
                    },
                },

            },
            Tabs: {
                baseStyle: {
                    color: 'white',
                },
            },
            Checkbox: {
                baseStyle: {
                    control: {
                        ...brandRing,
                        
                            _disabled: {
                                opacity: 0.4,
                              
                            }
                        
                    },

                },
            },
            Container: {
                baseStyle: {
                    //  padding: 0,
                    //  margin: 0,
                },
                sizes: {
                    sm: {
                        maxWidth: '50%',
                        w: '50%'
                    },
                    xl: {
                        maxWidth: '100%',
                        w: '100%'
                    }
                },
            },

        },
    },
    withDefaultColorScheme(
        {
            colorScheme: 'brand',
            components: ['Checkbox'],
        }),
    /*  withDefaultVariant({
        variant: 'outline',
        components: ['Input', 'NumberInput', 'PinInput'],
      }),   */

);

export default theme;
